import React from 'react';
import { Pagination } from 'antd';

const PaginationComponent = ({ defaultCurrent, total, CurrentPageNumber }) => {
  console.log('Pagination Component', defaultCurrent, total, CurrentPageNumber)
  const handlePageChange = (page, pageSize) => {
    console.log('Current Page:', page, pageSize);
    CurrentPageNumber(page, pageSize)
    // Here, you can do whatever you want with the current page number
    // For example, you can set it to a state variable or pass it to a parent component
  };

  return (
    <Pagination
      showSizeChanger={false}
      pageSize={50}
      defaultCurrent={defaultCurrent}
      total={total}
      onChange={handlePageChange}
      // pageSizeOptions={['25', '50', '75']}
    />
  );
}

export default PaginationComponent;
